<template>
	<div>
		<v-form ref="wholesaler_edit_form"  class="custome-form" lazy-validation @submit.prevent="save()">
			<v-row >
				<v-col cols="12" md="6">
					<v-row >
						<v-col cols="12" md="8" class="py-0 px-2">
							<div>
								<label> {{$lang.FIRM_NAME}}</label>
								<v-text-field
								:placeholder="$lang.FIRM_NAME"
								v-model="form.firm_name"
								single-line
								outlined
								dense
								:rules="$rules.firmNameRule"
								></v-text-field>
							</div>

							<div>
								<label> {{$lang.MOBILE_NO}}</label>
								<v-text-field
								:placeholder="$lang.MOBILE_NO"
								v-model="form.mobile"
								:disabled="(is_edit && $store.state.user_type==$keys.WHOLESALER)?true:false"
								single-line
								outlined
								dense
								maxlength="10"
								:rules="$rules.mobileRule"
								></v-text-field>
							</div>

							<div>
								<label> {{$lang.LANDLINE_NO}}</label>
								<v-text-field
								:placeholder="$lang.LANDLINE_NO"
								v-model="form.landline_number"
								single-line
								outlined
								dense
								maxlength="11"
								:error-messages="(form.landline_number)&&(form.mobile==form.landline_number)?$messages.MATCHING_PHONE_NUMBER_ERROR:''"
								:rules="$rules.landlineNumberRule"
								></v-text-field>
							</div>

							<div>
								<label> {{$lang.EMAIL_ID}}</label>
								<v-text-field
								:placeholder="$lang.EMAIL_ID"
								v-model="form.email"
								single-line
								outlined
								dense
								:rules="$rules.emailRule"
								></v-text-field>

							</div>

							<div>
								<label> {{$lang.SHOP_NO}}</label>

								<v-text-field
								:placeholder="$lang.SHOP_NO"
								v-model="form.shop_number"
								single-line
								outlined
								dense
								></v-text-field>
							</div>

							<div>
								<label> {{$lang.PIN_CODE}}</label>

								<v-text-field
								:placeholder="$lang.PIN_CODE"
								v-model="form.pincode"
								single-line
								outlined
								dense
								maxlength="6"
								:rules="$rules.pinCodeRule"
								></v-text-field>
							</div>
						</v-col>
					</v-row >
				</v-col>
				<!-- gstin  -->
				<v-col cols="12" md="" class="py-0 px-2">
					<v-row >
						<v-col cols="12" md="8" class="py-0 px-2">
							<div>
								<label> {{$lang.FULL_ADDRESS}}</label>
								<v-textarea
								clearable
								:placeholder="$lang.FULL_ADDRESS"
								v-model="form.full_address"
								single-line
								outlined
								dense
								auto-grow
								rows="2"
								:rules="$rules.fullAddressRule"
								></v-textarea>
							</div>

							<div>
								<label> {{$lang.CITY}}</label>
								<v-select
								v-model="form.city"
								:items="city_list"
								item-text="city_name"
								item-value="city_name"
								:placeholder="$lang.CITY"
								@focus="cityAutoComplete"
								@change="setState"
								append-icon="mdi-menu-down"
								single-line
								outlined
								dense
								return-object
								:rules="$rules.cityRule"
								:loading="city_loading"
								>
								<template v-slot:selection="{ item}">
									{{ item.city_name }}, {{ item.state_name }}								
								</template>

								<template v-slot:item="data">
									<v-list-item-content>
										<v-list-item-title v-html="data.item.city_name"></v-list-item-title>
										<v-list-item-subtitle >{{data.item.state_name}}</v-list-item-subtitle>
									</v-list-item-content>
								</template>
							</v-select>
						</div>
						
						<div>
							<label> {{$lang.GST_NUMBER}}</label>
							<v-text-field
							:placeholder="$lang.GST_NUMBER"
							v-model="form.gst_number"
							single-line
							outlined
							dense
							maxlength="15"
							:rules="$rules.gstNumberRule"
							></v-text-field>
						</div>
						<v-btn color="primary" class="signup-btn-style" type="submit" :loading="btn_loading">
							{{$lang.SAVE}}
						</v-btn>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-form>
</div>
</template>
<script type="text/javascript">

export default {
	components: {
	},
	data () {
		return {
			wholesaler_id:"",
			is_edit:false,
			btn_loading:false,
			form:{
				wholesaler_id:"",
				firm_name:"",
				mobile:"",
				landline_number:"",
				email_id:"",
				shop_number:"",
				pincode:"",
				full_address:"",
				city:"",
				state:"",
				gst_number:"",
				warehouse:"",
			},

			city_loading:false,
			city_list:[],

		}
	},
	created(){
		if (this.$route.params.wholesaler_id){
			this.wholesaler_id= this.decrypt(this.$route.params.wholesaler_id)
			this.is_edit=true
			this.getWholeSalerDetails();
		}
		if (this.$route.name=="wholesaler-edit-profile"){
			this.is_edit=true
			this.getWholeSalerDetails();
		}
		
		this.cityAutoComplete()
	},
	methods:{
		/* fetch wholesaler details */ 
		getWholeSalerDetails(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				wholesaler_id:self.wholesaler_id
			};

			const successHandler = (response) => {
				if(response.data.success){
					self.form=response.data.data
					self.form.city={
						city_name:response.data.data.city,
						state_name:response.data.data.state
					}
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.WHOLESALER_PROFILE,params,successHandler,null,null,finallyHandler)

		},
		/* set the  selected city and state */ 
		setState(item){
			console.log(item)
			if(item){
				console.log(item.state_name)
				this.form.state=item.state_name
				this.$emit('get-state',item.state_name)
			}		
			else
				this.form.state=""
		},

		/* save wholesaler profile*/ 
		save(){
			const self=this;
			console.log(this.form)
			if (this.$refs.wholesaler_edit_form.validate()==false)
				return false

			self.btn_loading=true
			var	 form = new URLSearchParams();
			form.append("wholesaler_id",self.form.wholesaler_id);
			form.append("firm_name",self.form.firm_name);
			form.append("mobile",self.form.mobile);
			form.append("landline_number",self.form.landline_number);
			form.append("email",self.form.email);
			form.append("shop_number",self.form.shop_number);
			form.append("pincode",self.form.pincode);
			form.append("full_address",self.form.full_address);
			if(self.form.city.city_name)
				form.append("city",self.form.city.city_name);
			else
				form.append("city",self.form.city);
			form.append("state",self.form.state);
			form.append("gst_number",self.form.gst_number);

			let url=this.$urls.REGISTER_WHOLESALER
			if (this.is_edit){
				url=this.$urls.WHOLESALER_EDIT
			}
			const successHandler = (response) => {
				if(response.data.success){
					self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.PROFILE_SAVED, color:self.$keys.SUCCESS })
					if (this.$store.state.user_type==this.$keys.WHOLESALER)
						self.$router.push({name:'wholesaler-profile-details'})
					else{
						let wholesaler_id=self.form.wholesaler_id
						if (!self.is_edit)
							wholesaler_id=response.data.data.wholesaler_id

						this.$router.push({name:'wholesaler-details',params:{wholesaler_id:this.encript(wholesaler_id)}})
					}
				}
			};
			const finallyHandler = () => {
				self.btn_loading=false
			};
			this.request_POST(self,url,form,successHandler,null,null,finallyHandler)

		}

	}

}
</script>